import {Tenant} from '@model/tenant';
import {ToastrService} from 'ngx-toastr';
import {Globals} from '@theme/utils/globals';
import {Component, OnInit} from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {RentService} from '@service/rent/rent.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TenantService} from '@service/tenant/tenant.service';
import {EmitterService} from '@service/emitter/emitter.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-tenant-wallet',
  templateUrl: './tenant-wallet.component.html',
  styleUrls: ['./tenant-wallet.component.scss']
})
export class TenantWalletComponent implements OnInit {
  title: string = '';
  type: string = '';
  dateM = '';
  form: FormGroup;
  submit: boolean = false;
  tenant: Tenant;
  required = Globals.required;

  constructor(
    public modal: NgbActiveModal,
    public toastr: ToastrService,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private tenantService: TenantService
  ) {
    this.tenant = this.tenantService.getTenant()
    this.type = this.tenantService.wallet
    this.title = 'Modifier les informations du wallet';
    this.newForm();
    this.f.type.setValue(this.type)
    if (this.tenant) {
      this.f.tenant.setValue(this.tenant.uuid)
    }
  }

  ngOnInit(): void {
  }

  newForm() {
    this.form = this.formBuild.group({
      uuid: [null],
      id: [null],
      type: [null, [Validators.required]],
      tenant: [null, [Validators.required]],
      montant: [0, [Validators.required]],
    });
  }
  onSubmit() {
    this.submit = true;
    if (this.form.valid) {
      var data = this.form.getRawValue()
      this.tenantService.updateWAllet(data).subscribe(
        res => {
          if (res?.status === 'success') {
            this.modal.dismiss();
            this.modal.close('ferme');
            this.emitter.emit({action: 'TENANT_UPDATE', payload: res?.data});
          }
          this.emitter.stopLoading();
        },
        error => {
        });
    } else {
      this.toast('Votre formualire n\'est pas valide.', 'Attention !', 'warning');
      return;
    }
  }
  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Confirmez-vous l\'enregistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmer <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.onSubmit();
      }
    });
  }
  onClose(){
    this.form.reset()
    this.modal.close('ferme');
  }
  onReset(){
    this.form.reset()
  }
  toast(msg, title, type) {
    if (type == 'info') {
      this.toastr.info(msg, title);
    } else if (type == 'success') {
      this.toastr.success(msg, title);
    } else if (type == 'warning') {
      this.toastr.warning(msg, title);
    } else if (type == 'error') {
      this.toastr.error(msg, title);
    }
  }
  get f() { return this.form.controls; }
}

